import React, { Component } from 'react';
import './InformationNotice.css';
import NoticeItem from "./NoticeItem/NoticeItem";
import InformationNoticePagination from "./InformationNoticePagination/InformationNoticePagination";
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";

class InformationNotice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: props.userId,
            articles: [],
            totalItemCount: 0,
            activePage: 1
        };
        this.getArticles = this.getArticles.bind(this);
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props !== prevProps){
            this.getArticles();
        }
    }

    componentDidMount() {
        this.getArticles();
    }

    getArticles = (offset, limit) => {
        offset=0;
        limit=5;
        axios.get(RESOURCE_BASE_URL + 'api/articles?offset=' + offset + '&limit=' + limit )
            .then((res) => {
                console.log("aaaaaa==========> ", res.data.articles);
                this.setState({
                    articles: res.data.articles.content,
                    totalItemCount: res.data.rowCount
                });
            })
            .catch((err) => {
                this.setState(
                    {
                        inquiries: []
                    });
                console.log("[API] ERROR: ", err);
            });
    };
    /*getArticlesForPagination = (offset, limit) => {
        axios.get(RESOURCE_BASE_URL + 'api/articles?offset=' + offset + '&limit=' + limit )
            .then((res) => {
                this.setState({
                    articles: res.data.articles,

                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };*/
    render(){
        let sortJsonArray = require('sort-json-array');
        let sortedArticles=sortJsonArray(this.state.articles, 'createdDate','des');
        return(
            <div className="row information-div">
                <div className="information-text">
                    {/*<FormattedMessage id="app.home-content.info-notice.heading"*/}
                                      {/*defaultMessage="Information"*/}
                                      {/*description=""/>*/}
                    インフォメーション
                    <br/>
                </div>
                {/*<div className="notice-text">
                    <FormattedMessage id="app.home-content.info-notice.notice"
                                      defaultMessage="Notice"
                                      description=""/>
                </div>*/}
                <div className="notice-items">
                    {sortedArticles.map(article => {
                        return <NoticeItem key={article.id} article={article}/>;

                    })}

                </div>
                <div className="information-notice-pagination">
                    {/*<InformationNoticePagination/>*/}

                </div>
            </div>
        );
    }
}
export default InformationNotice;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/InformationNotice/InformationNotice.js